module.exports = __webpack_public_path__ + "img/img4.e9582f1a.jpg";